import React from "react";
import FaqCategoryContainer from "containers/Faq/FaqCategory";

const FaqCategoryPage = () => {
  return (
    <>
      <FaqCategoryContainer />
    </>
  );
};

export default FaqCategoryPage;
